module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('jin-dialog', {
    attrs: {
      "custom-class": "vip-dialog",
      "size": "mini"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "vip-dialog__h",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/vip-dialog-icon.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vip-dialog__b"
  }, [_c('h3', [_vm._v(_vm._s(_vm.dialogTitle) + "~")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.textContent))])]), _vm._v(" "), _c('div', {
    staticClass: "vip-dialog__f"
  }, [_c('button', {
    staticClass: "vip-dialog__button plain",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("我知道了")]), _vm._v(" "), _c('button', {
    staticClass: "vip-dialog__button",
    on: {
      "click": _vm.onVipClick
    }
  }, [_vm._v(_vm._s(_vm.submitBtnText))])]), _vm._v(" "), (_vm.pageType === 'tradingNew' || _vm.liveType === 'tradingNew') ? _c('a', {
    staticClass: "upgrade-vip-tips",
    attrs: {
      "href": "https://www.jin10.com/vip_payment/index.html#/"
    },
    on: {
      "click": _vm.onLinkClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.footerText) + " >>\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46cb3bca","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/Content/src/VipDialog.vue
// module id = 7EpH
// module chunks = 2 3 4 6 7 8 9